export default __webpack_public_path__ + "static/media/i022vp.496547fc.webp";